export type TagType = (typeof TAG_TYPES)[number];

export const TAG_TYPES = [
  "action",
  "alert",
  "api-key",
  "bookmark",
  "cache-config",
  "card",
  "channel",
  "cloud-migration",
  "collection",
  "collection-tree",
  "content-translation",
  "dashboard",
  "dashboard-question-candidates",
  "database",
  "dataset",
  "document",
  "external-transform",
  "public-document",
  "comment",
  "embedding-hub-checklist",
  "field",
  "field-values",
  "glossary",
  "indexed-entity",
  "llm-models",
  "logger-preset",
  "measure",
  "model-index",
  "notification",
  "parameter-values",
  "permissions-group",
  "persisted-info",
  "persisted-model",
  "revision",
  "group-table-access-policy",
  "schema",
  "segment",
  "session-properties",
  "slack-app-info",
  "snippet",
  "subscription",
  "subscription-channel",
  "table",
  "task",
  "task-run",
  "timeline",
  "timeline-event",
  "transform",
  "transform-tag",
  "transform-job",
  "transform-job-via-tag",
  "transform-run",
  "transform-inspector-lens",
  "user",
  "public-dashboard",
  "embed-dashboard",
  "public-card",
  "embed-card",
  "public-action",
  "unique-tasks",
  "user-key-value",
  "tenant",
  "metabot",
  "metabot-entities-list",
  "metabot-prompt-suggestions",
  "metabot-permissions",
] as const;

export const TAG_TYPE_MAPPING = {
  collection: "collection",
  "content-translation": "content-translation",
  card: "card",
  dashboard: "dashboard",
  database: "database",
  document: "document",
  "indexed-entity": "indexed-entity",
  measure: "measure",
  table: "table",
  dataset: "card",
  action: "action",
  segment: "segment",
  metric: "card",
  snippet: "snippet",
  pulse: "subscription",
  transform: "transform",
} as const;
